import ApplicationAdapter from 'eflex/adapters/application';

export default class UniversalRobotAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
